import { REALTIME_DEPARTURE_POSITION_SUCCESS } from "../types"

const initialState = {
  message: null,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case REALTIME_DEPARTURE_POSITION_SUCCESS:
      return {
        ...state,
        message: action.payload,
      }
    default:
      return state
  }
}
